import { render } from "./ShoppingListContentPrint.vue?vue&type=template&id=23322b8a&scoped=true"
import script from "./ShoppingListContentPrint.vue?vue&type=script&lang=js"
export * from "./ShoppingListContentPrint.vue?vue&type=script&lang=js"

import "./ShoppingListContentPrint.vue?vue&type=style&index=0&id=23322b8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23322b8a"]])

export default __exports__